import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { hostListQueries } from '@/services/hostManagement/hostManagement.queries';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate, useParams } from '@tanstack/react-router';
import { toast } from 'sonner';

const useAddHostInfo = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const params = useParams({ from: '/(app)/store-information/basic-stores/host-management/$clubid' });
  const { mutateAsync } = useMutation('createHostInfo', {
    onError: (err) => {
      toast.error(err.message);
    },
    onSuccess: async (res) => {
      toast.success(res.message);
      await queryClient.invalidateQueries({ queryKey: [...hostListQueries.all()] });
      void navigate({
        to: '/store-information/basic-stores/host-management/$clubid',
        params: {
          clubid: params['clubid'],
        },
      });
      await revalidate(['hostDetail', 'clubHosts']);
    },
  });
  return { mutateAsync };
};

export default useAddHostInfo;
